import { type FragmentOf, graphql, readFragment } from "@opensea/graphql"
import type { CollectionOverviewMediaType } from "../types"

export const getMediaPropsFromMediaFragment = graphql(`
  fragment MediaProps on Media {
    __typename
    ... on ImageMedia {
      imageUrl
    }
    ... on VideoMedia {
      videoUrl
      aspectRatio
      thumbnailUrl
    }
    ... on MuxVideoMedia {
      muxPlaybackId
      aspectRatio
      thumbnailUrl
    }
  }
`)

export const getMediaPropsFromMedia = (
  mediaKey?: FragmentOf<typeof getMediaPropsFromMediaFragment> | null,
): CollectionOverviewMediaType | null => {
  const media = readFragment(getMediaPropsFromMediaFragment, mediaKey)
  if (!media) {
    return null
  }
  return {
    mediaType: media.__typename,
    imageUrl: media.__typename === "ImageMedia" ? media.imageUrl : null,
    videoUrl: media.__typename === "VideoMedia" ? media.videoUrl : null,
    muxPlaybackId:
      media.__typename === "MuxVideoMedia" ? media.muxPlaybackId : null,
    aspectRatio: media.__typename !== "ImageMedia" ? media.aspectRatio : null,
    thumbnailUrl: media.__typename !== "ImageMedia" ? media.thumbnailUrl : null,
  } as CollectionOverviewMediaType
}
